import { WeekStartDay } from '@retailer-platform/shared-components/src/common/date-range-picker/utils/DateRangePickerPresets.utils'

export type GroupByOptionValue =
  | 'DATE_PT'
  | 'WEEK_SUN_PT'
  | 'WEEK_SAT_PT'
  | 'WEEK_MON_PT'
  | 'WEEK_TUE_PT'
  | 'WEEK_WED_PT'
  | 'WEEK_THU_PT'
  | 'WEEK_FRI_PT'
  | 'MONTH_PT'

export const startDayToGroupByValue: Record<WeekStartDay, GroupByOptionValue> = {
  [WeekStartDay.Sunday]: 'WEEK_SUN_PT',
  [WeekStartDay.Monday]: 'WEEK_MON_PT',
  [WeekStartDay.Tuesday]: 'WEEK_TUE_PT',
  [WeekStartDay.Wednesday]: 'WEEK_WED_PT',
  [WeekStartDay.Thursday]: 'WEEK_THU_PT',
  [WeekStartDay.Friday]: 'WEEK_FRI_PT',
  [WeekStartDay.Saturday]: 'WEEK_SAT_PT',
}
